import { jsx as _jsx, jsxs as _jsxs } from "react/jsx-runtime";
import { Box, Stack } from "native-base";
import { useTranslation } from "@madmedical/i18n";
import Paper from "../../atoms/Paper";
import Headline from "../../molecules/Headline";
import DeviceCard from "../../organisms/DeviceCard";
import { useDevices } from "../../providers/device";
const Devices = () => {
    const { devices } = useDevices();
    const { t } = useTranslation();
    return (_jsxs(Paper, { children: [_jsx(Headline, { title: t("devices"), size: "xs", py: 6 }), _jsx(Stack, Object.assign({ direction: "row", px: 4, py: 2, space: 0, width: "full", flexWrap: "wrap" }, { children: devices.map((device) => (_jsx(Box, Object.assign({ width: "1/3", p: 1 }, { children: _jsx(DeviceCard, { device: device }) }), device.provider))) }))] }));
};
export default Devices;
